module.exports = __webpack_public_path__ + "static/media/da-contact-1.ce1cc03d.jpg";